import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter, Link } from 'react-router-dom';
import Sticky from 'react-stickynode';
import isEmpty from 'lodash/isEmpty';

import BaseObjectField from './BaseObjectField';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Tabs, { Tab } from 'material-ui/Tabs';
import Badge from 'material-ui/Badge';
import Button from 'material-ui/Button';
import { getCurrentUserRole } from '../../../../user/user.selectors';
import { UserRoles } from '../../../../user/user.constants';
import { getInspectionById } from '../../../../inspection/inspection.selectors';
import { validateCostEstimate } from '../../../../../utils/inspection-utils';
import { getCostEstimateForType } from '../../../../costEstimate/costEstimate.selectors';
import { CostEstimateForm } from '../../../../costEstimate/components';
import * as actions from '../../../../costEstimate/costEstimate.actions';

const styles = theme => ({
  tabs: {
    backgroundColor: theme.palette.common.white,
  },
  label: {
    fontSize: '10px !important',
  },
  badge: {
    backgroundColor: theme.palette.error['A400'],
    fontSize: 10,
    color: '#fff',
    top: -theme.spacing.unit / 2,
    right: -theme.spacing.unit * 2.5,
    width: theme.spacing.unit * 2,
    height: theme.spacing.unit * 2,
  },
  appBar: {
    borderLeft: '1px solid #fff',
    borderTop: '1px solid #fff',
    borderRight: '1px solid #fff',
    backgroundColor: '#fff',

    a: {
      color: '#29694D',
    },
  },
  footer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
});

class TabsComponent extends Component {
  state = {
    value: 'perustiedot',
  };
  componentDidMount = () => {
    const { readCostEstimates, id } = this.props;
    readCostEstimates(id);
  };
  componentWillReceiveProps(nextProps) {
    // console.log('TabsComponent willReceiveProps:', nextProps);
    const { formContext, history, orderedProperties } = nextProps;
    const nextPropsTab = nextProps.match.params.tab;
    if (!nextPropsTab) {
      history.push(
        `/inspection/edit/${formContext._id}/${orderedProperties[0]}`
      );
    } else if (nextPropsTab && this.state.value !== nextPropsTab) {
      this.setState({
        value: nextPropsTab,
      });
    }
  }

  onChangeTab = (event, value) => {
    this.setState({ value });
  };

  isWaitingForCostEstimate = (status, isInspector) => {
    return status === 'signed';
  };

  onNextClick = event => {
    event.preventDefault();
    const { history, sellerCostEstimate, departmentCostEstimate } = this.props;
    const { value } = this.state;
    const link = this.nextLink();
    if (value === 'estimate') {
      let estimate = null;
      if (sellerCostEstimate && sellerCostEstimate.status !== 'completed')
        estimate = 'sellerEstimate';
      else if (
        departmentCostEstimate &&
        departmentCostEstimate.status !== 'completed'
      )
        estimate = 'departmentEstimate';
      this._costEstimateForm.submit(estimate, () => {
        history.push(link);
      });
    } else {
      history.push(link);
    }
  };

  onReturnClick = event => {
    const { history } = this.props;
    history.push('/');
  };

  hasCostestimate = costEstimate => {
    return (
      costEstimate &&
      (costEstimate.sellerCostEstimate !== null ||
        costEstimate.departmentCostEstimate !== null)
    );
  };

  nextLink = () => {
    const { value } = this.state;
    const { formContext, orderedProperties } = this.props;
    const { formStatus, costEstimate } = formContext;
    const index = orderedProperties.indexOf(value);
    let title = '';
    if (value === 'estimate') {
      title = `/`;
    } else if (index < orderedProperties.length - 1) {
      const newValue = orderedProperties[index + 1];
      title = `/inspection/edit/${formContext._id}/${newValue}`;
    } else if (
      index === orderedProperties.length - 1 &&
      this.isWaitingForCostEstimate(formStatus) &&
      this.hasCostestimate(costEstimate)
    ) {
      title = `/inspection/edit/${formContext._id}/estimate`;
    }
    return title;
  };

  render() {
    const {
      classes,
      errorSchema,
      children,
      formContext,
      orderedProperties,
      schema,
      isInspector,
      inspection,
      role,
      sellerCostEstimate,
      departmentCostEstimate,
    } = this.props;
    const {
      isFormValid,
      formStatus,
      shouldStrictValidate,
      costEstimate,
    } = formContext;
    let { value } = this.state;
    const hasCostestimate = this.hasCostestimate(costEstimate);
    // console.log('TabsComponent render, state:', value);
    const currentTabIindex = this.props.orderedProperties.indexOf(value);
    const hasReturnButton =
      currentTabIindex === orderedProperties.length - 1 &&
      isFormValid &&
      !hasCostestimate &&
      (formStatus === 'signed' ||
        inspection.status === 'waitingForInspectorPricing' ||
        inspection.status === 'waitingForDepartmentPricing');
    // non valid, non signed, non waiting > disable
    const isSellerCostEstimateCompleted = validateCostEstimate(
      sellerCostEstimate
    );
    const isDepartmentCostEstimateCompleted = validateCostEstimate(
      departmentCostEstimate
    );
    const isSellerPending = isInspector && !isSellerCostEstimateCompleted;
    const isDepartmentPending =
      (role === UserRoles.DEPARTMENT || role === UserRoles.SUPERUSER) &&
      (!isSellerCostEstimateCompleted ||
        (sellerCostEstimate &&
          sellerCostEstimate.status === 'completed' &&
          !isDepartmentCostEstimateCompleted &&
          inspection.status !== 'completed'));

    const submitDisabled =
      (currentTabIindex === orderedProperties.length - 1 &&
        (!isFormValid || formStatus !== 'signed')) ||
      (value === 'estimate' &&
        formStatus !== 'completed' &&
        (isSellerPending || isDepartmentPending));

    const linkContext = () => {
      let link = '/inspection/';
      if (formStatus === 'completed') {
        link += 'view/';
      } else {
        link += 'edit/';
      }
      return link;
    };
    const nextLabel = value => {
      let s = formContext.formSchema.id === "wagri.inspection.wagri" ? 'Järgmine' : 'Seuraava';
      
      if (
        value === 'estimate' ||
        (!hasCostestimate &&
          currentTabIindex === this.props.orderedProperties.length - 1)
      ) {
        s = 'Lähetä';
      }
      return s;
    };

    const closeLabel = formContext.formSchema.id === "wagri.inspection.wagri" ? 'Sulge' : 'Sulje';

    // console.log('value:' + value + ' currentTabIindex:' + currentTabIindex + ' op len:' + (this.props.orderedProperties.length - 1) + ' hasCostestimate:' + hasCostestimate + ' formStatus:' + formStatus)

    return (
      <div>
        <Sticky>
          <AppBar position="static" elevation={0}>
            <Tabs
              value={value}
              onChange={this.onChangeTab}
              fullWidth
              className={classes.tabs}
              textColor="accent"
            >
              {orderedProperties.map((name, index) => {
                const hasError = !isEmpty(errorSchema[name]);
                const shouldShowError = hasError && shouldStrictValidate;
                const labelContent = !shouldShowError ? (
                  schema.properties[name].title
                ) : (
                  <Badge
                    key={index}
                    badgeContent={'!'}
                    classes={{ badge: classes.badge }}
                  >
                    {schema.properties[name].title}
                  </Badge>
                );
                return (
                  <Tab
                    key={index}
                    component={Link}
                    value={name}
                    to={linkContext() + `${formContext._id}/${name}`}
                    //label={schema.properties[name].title}
                    label={labelContent}
                    classes={{
                      label: classes.label,
                    }}
                  />
                );
              })}
              {hasCostestimate &&
                this.isWaitingForCostEstimate(formStatus) && (
                  <Tab
                    component={Link}
                    value={'estimate'}
                    to={linkContext() + `${formContext._id}/estimate`}
                    //label={schema.properties[name].title}
                    label={'Hinta-arvio'}
                    classes={{
                      label: classes.label,
                    }}
                  />
                )}
            </Tabs>
          </AppBar>
        </Sticky>
        {value === 'estimate' ? (
          <CostEstimateForm
            onRef={costEstimate => {
              this._costEstimateForm = costEstimate;
            }}
          />
        ) : (
          children.map((child, index) => {
            return child.props.name === value ? child : null;
          })
        )}
        <footer className={classes.footer}>
          {!hasReturnButton && (
            <Button
              raised
              color="accent"
              onClick={this.onNextClick}
              title={this.nextLink()}
              disabled={submitDisabled}
            >
              {nextLabel(value)}
            </Button>
          )}
          {hasReturnButton && (
            <Button
              raised
              color="accent"
              onClick={this.onReturnClick}
              title={'/'}
            >
              {closeLabel}
            </Button>
          )}
        </footer>
      </div>
    );
  }
}

TabsComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  formContext: PropTypes.object.isRequired,
  errorSchema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  options: PropTypes.array,
  orderedProperties: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  isInspector: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, { match, backPath }) => {
  const { params: { id } } = match;
  backPath = '/';
  const role = getCurrentUserRole(state);
  const isInspector = role && role === UserRoles.INSPECTOR;
  const inspection = getInspectionById(state, id);
  const sellerCostEstimate = getCostEstimateForType(state, 'seller', id);
  const departmentCostEstimate = getCostEstimateForType(
    state,
    'department',
    id
  );
  // const rand = Math.random() * 1000;

  // const logObj = {
  //   backPath: backPath,
  //   id: id,
  //   isInspector: isInspector,
  //   rand: rand
  // };
  // console.log('TabsComponent mapStateToProps:', logObj);

  return {
    backPath,
    id,
    role,
    isInspector,
    inspection,
    sellerCostEstimate,
    departmentCostEstimate,
  };
};

const enhance = compose(
  withProps({
    RootComponent: withRouter(
      connect(mapStateToProps, actions)(withStyles(styles)(TabsComponent))
    ),
  })
);

const TabsField = enhance(BaseObjectField);

export default TabsField;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/TabsField.js